import _ from 'underscore';

export default function CurrentUserService($http, $q) {
  const get = _.throttle(
    () =>
      $q
        .resolve()
        .then(() => $http.get('/users/current').then(({ data }) => data.user)),
    2000,
    {
      trailing: false
    }
  );

  function isAdmin() {
    return get().then(user => user && user.admin);
  }

  return {
    get,
    isAdmin
  };
}

CurrentUserService.$inject = ['$http', '$q'];
